//
import classNames from 'classnames';
import React, { FC } from 'react';

import styles from './NewsTag.module.scss';

export enum TagType {
  shehui = '社会责任',
  lingshou = '零售业务',
  keji = '科技创新',
  caiwu = '财务报告',
  gongzuo = '工作在美团',
  piyao = '辟谣公告',
  qishou = '骑手保障',
  shangjia = '商家生态',
  suanfa = '算法公开',
}

const TagTypeKeyMap = new Map<number | string, string>()
  .set(2, 'gongzuo')
  .set(3, 'caiwu')
  .set(1, 'shehui')
  .set(4, 'keji')
  .set(5, 'lingshou')
  .set(8, 'piyao')
  .set(6, 'qishou')
  .set(7, 'shangjia')
  .set(9, 'suanfa');

// tagVal=shehui
interface Props {
  tagVal: number | string;
  tagName: string;
}
const NewsTag: FC<Props> = (props) => {
  const { tagVal, tagName } = props;

  const tagTpyeClass = TagTypeKeyMap.get(tagVal) || 'dafalut';

  return <span className={classNames(styles['news-tag'], styles[tagTpyeClass])}>{tagName}</span>;
};
NewsTag.defaultProps = {};

NewsTag.displayName = 'NewsTag';
export default NewsTag;
